export default __webpack_public_path__ + "static/montserrat-v15-latin-ext_latin-regular-35b478a95ecaa73a446aef16db89a79b.woff2";